var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4999 5.5C13.4999 6.32843 12.8284 7 11.9999 7C11.1715 7 10.4999 6.32843 10.4999 5.5C10.4999 4.67157 11.1715 4 11.9999 4C12.8284 4 13.4999 4.67157 13.4999 5.5ZM12.75 8.40547C14.0439 8.07242 14.9999 6.89786 14.9999 5.5C14.9999 3.84315 13.6568 2.5 11.9999 2.5C10.3431 2.5 8.99994 3.84315 8.99994 5.5C8.99994 6.8979 9.95605 8.07249 11.25 8.4055V11.75H4.00005H3.25005V12.5V15.5945C1.9561 15.9275 1 17.1021 1 18.5C1 20.1569 2.34315 21.5 4 21.5C5.65685 21.5 7 20.1569 7 18.5C7 17.1021 6.04394 15.9276 4.75005 15.5945V13.25H11.25V15.5945C9.95605 15.9275 8.99995 17.1021 8.99995 18.5C8.99995 20.1569 10.3431 21.5 12 21.5C13.6568 21.5 15 20.1569 15 18.5C15 17.1021 14.0439 15.9276 12.75 15.5945V13.25H19.2501V15.5945C17.9561 15.9275 17 17.1021 17 18.5C17 20.1569 18.3431 21.5 20 21.5C21.6568 21.5 23 20.1569 23 18.5C23 17.1021 22.0439 15.9276 20.7501 15.5945V12.5V11.75H20.0001H12.75V8.40547ZM13.5 18.5C13.5 19.3284 12.8284 20 12 20C11.1715 20 10.5 19.3284 10.5 18.5C10.5 17.6716 11.1715 17 12 17C12.8284 17 13.5 17.6716 13.5 18.5ZM20 20C20.8284 20 21.5 19.3284 21.5 18.5C21.5 17.6716 20.8284 17 20 17C19.1716 17 18.5 17.6716 18.5 18.5C18.5 19.3284 19.1716 20 20 20ZM5.5 18.5C5.5 19.3284 4.82843 20 4 20C3.17157 20 2.5 19.3284 2.5 18.5C2.5 17.6716 3.17157 17 4 17C4.82843 17 5.5 17.6716 5.5 18.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranches);
export default __webpack_public_path__ + "static/media/branches.0cad911598e08d30b223c68fc0c10a30.svg";
export { ForwardRef as ReactComponent };